import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { TypeParams } from '../../types'

import { Plugin } from './plugin'

/** Factory for record-assignable-labs Space dimension-filter plugin instances. */
export class Factory
  implements ec.plugins.Plugin.Factory<TypeParams, typeof Plugin.id, Plugin>
{
  /** @see {@link Plugin.id} */
  public readonly id = Plugin.id

  /** @see {@link ec.plugins.Plugin.Factory.produceFor} */
  public produceFor(collection: ec.Collection<TypeParams>): Plugin {
    return new Plugin({ collection })
  }
}
